import { apiUrl, apiUrl2 } from '../../../settings'

export const addCountryUrl = () => {
  return apiUrl + '/country'
}

export const listCountriesUrl = () => {
  return apiUrl + '/country'
}

export const listCountryUrl = (id) => {
  return apiUrl + '/country/' + id
}

export const updateCountryStatusUrl = () => {
  return apiUrl + '/api/update-country-status'
}
